<template>
    <Button @click.stop="confirmar()" v-if="$temAcessoView('CTRLACS-APP-04')" class="ml-2" icon="pi pi-key" label="Recriar Token" />
</template>

<script>
import AplicacoesServicos from './services';

export default {
    props: {
        aplicacao: {
            type: Object,
        },
    },

    methods: {
        confirmar() {
            this.$confirm.require({
                message: `Tem certeza que deseja Recriar o token?`,
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.recriar();
                },
            });
        },

        recriar() {
            this.$store.dispatch('addRequest');
            AplicacoesServicos.recriarToken(this.aplicacao).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.add({
                            severity: 'success',
                            summary: 'Recriar token',
                            detail: 'Token recriado com sucesso!',
                            life: 3000,
                        });
                        this.$emit('atualizarAplicacao', response.data);
                    } else {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Recriar token',
                            detail: 'Falha ao recriar token',
                            life: 3000,
                        });
                    }
                }
                this.$store.dispatch('removeRequest');
            });
        },
    },
};
</script>
